import React from "react";
import { useNavigate } from "react-router-dom";
import { EndCreateMission } from "assets/icons";
import Banner from "components/banner/banner";
import Button from "components/button/index.js";
import UseContext from "hooks/useContext";
import MissionCreatedContent from "pages/createMission/components/MissionCreatedContent";

const End = () => {
    const navigate = useNavigate();
    const { createdMissionId } = UseContext();
    const handleNavigation = () => {
        navigate("/missions/comingSoon");
    };
    // The api gave the new mission's id: celebrate it. Otherwise, the former screen.
    if (createdMissionId) return <MissionCreatedContent missionId={createdMissionId}/>;

    return (
        <>
            <div className={"flex flex-col gap-4"}>
                <p className={"ft-sm text-yellow-500"}>Félicitations !</p>
                <h1 className={"ft-xl text-gray-900 font-medium"}>
                    Mission créée avec succès 🎉
                </h1>
                <p className="ft-sm text-gray-500 leading-relaxed">
                    Félicitations, votre mission est disponible pour tous les
                    intérimaires.
                </p>
                <Banner type={"info"}>
                    Gérez vos missions qui n’ont pas encore débutées dans la
                    page “À venir” de Missions.
                </Banner>
                <div className={"mx-auto"}>
                    <EndCreateMission w={350} h={180} />
                </div>
            </div>
            <div className="flex justify-end mt-10">
                <Button
                    size={"LG"}
                    color={"SECONDARY"}
                    onClick={handleNavigation}
                >
                    Missions à venir
                </Button>
            </div>
        </>
    );
};

export default End;
